// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShareImport_wrapper__29XMz","root":"ShareImport_root__18CXm"};